export default "__VITE_ASSET__Clmd1YAt__"